/**
 * DiceBear avatar URL builder - consistent avataaars style with RideSnap
 * brand-orange background across the app.
 */
export function getAvatarUrl(seed) {
    if (seed === null || seed === undefined) return null
    return `https://api.dicebear.com/7.x/avataaars/svg?seed=${seed}&backgroundColor=743814`
}
